import React, { Component } from 'react'

/**
 * Go to top button
 */
class GoToTop extends Component {
	constructor(props) {
		super(props);
		this.state = { scrollToTopButton: false };
	}
	componentDidMount() {

		window.addEventListener('scroll', () => {
			if(window.scrollY > 100) {
				this.setState({ scrollToTopButton: true});
			} else {
				this.setState({ scrollToTopButton: false});
			}
		})
	}

	handleGoToTop = (scrollDuration) => {
		let cosParameter = window.scrollY / 2,
			scrollCount = 0,
			oldTimestamp = performance.now();
		function step (newTimestamp) {
			scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp));
			if (scrollCount >= Math.PI) window.scrollTo(0, 0);
			if (window.scrollY === 0) return;
			window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
			oldTimestamp = newTimestamp;
			window.requestAnimationFrame(step);
		}
		window.requestAnimationFrame(step);
	};

	render() {
		const goToTopClass = `goToTop ${this.state.scrollToTopButton ? 'visible' : ''}`;
		return (
			(
				<section className={goToTopClass} onClick={() => this.handleGoToTop(300)}>
					<div />
				</section>
			)
		)
	}
}

export default GoToTop;




// WEBPACK FOOTER //
// ./src/components/go-to-top/index.jsx